import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Portfolio from './pages/Portfolio';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import FintechDashboard from './portfolio/FintechDashboard';
import EcommerceStore from './portfolio/EcommerceStore';
import AdminDashboard from './portfolio/AdminDashboard';
import JobBoard from './portfolio/JobBoard';
import LandingPage from './portfolio/LandingPage';
import SocialDashboard from './portfolio/SocialDashboard';

function App() {
  return (
    <Router>
      <div className="App min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/portfolio/fintech-dashboard" element={<FintechDashboard />} />
            <Route path="/portfolio/ecommerce-store" element={<EcommerceStore />} />
            <Route path="/portfolio/admin-dashboard" element={<AdminDashboard />} />
            <Route path="/portfolio/job-board" element={<JobBoard />} />
            <Route path="/portfolio/landing-page" element={<LandingPage />} />
            <Route path="/portfolio/social-dashboard" element={<SocialDashboard />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
